<template>
<div :class="classes"
        :id="isAdmin ? 'guidedtour_drawerleft_cgu' : ''">

    <q-btn label="Conditions d'utilisation" @click="link(route('terms'))" dense :flat="flat" :outline="outline" padding="none xs" no-caps :color="color" :size="size">
        <OpenInNewTab router="terms" />
    </q-btn>
    <br v-if="noInline"/>
    <!-- <inertia-link :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Politique de confidentialité</inertia-link> -->
    <q-btn label="Politique de confidentialité" @click="link(route('policy'))" dense :flat="flat" :outline="outline" padding="none xs" no-caps :color="color" :size="size">
        <OpenInNewTab router="policy" />
    </q-btn>
</div>
</template>

<script setup>
import { link } from '@helpers'
import OpenInNewTab from './partials/OpenInNewTab.vue'

const props = defineProps({
        classes: String,
        'no-inline': Boolean,
        color: {String, default: 'white'},
        size: {String, default: 'md'},
        flat: Boolean,
        outline: Boolean,
    })

// import { defineAsyncComponent } from 'vue'
// export default {
//     name: "TermsAndPolicyButtons",
//     components: {
//         OpenInNewTab: defineAsyncComponent(() => import() ),
//     },
//     props:{
//         classes: String,
//         'no-inline': Boolean,
//         color: {String, default: 'white'},
//         size: {String, default: 'md'},
//         flat: Boolean,
//         outline: Boolean,
//     }
// }
</script>
